"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbDRPicasoSession = void 0;
const cc_1 = require("../cc");
const types_1 = require("../cc/types");
const events_1 = require("../../../features/events");
const timeOut_helper_1 = require("../../../features/timeOut/helpers/timeOut.helper");
class MbDRPicasoSession extends cc_1.MbCCSession {
    constructor(sessionStorage, urlConfig, eventBus) {
        super(sessionStorage, eventBus);
        this.isDataValid = (data) => {
            if (data.entrypoint === types_1.EntrypointType.DRPicaso && data.agentToken) {
                return true;
            }
            return false;
        };
        this.getHeaders = () => {
            var _a;
            const data = this.getData();
            return {
                accessToken: (_a = data === null || data === void 0 ? void 0 : data.agentToken) !== null && _a !== void 0 ? _a : '',
            };
        };
        this.doRefresh = () => __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            if (!this.xhr) {
                throw Error('Set xhr before use DRPicasoSession');
            }
            try {
                (0, events_1.publishRefreshingSessionEvent)(undefined, this.eventBus);
                const actualSessionCCInfo = {
                    refreshToken: (_a = this.getData()) === null || _a === void 0 ? void 0 : _a.refreshToken,
                    username: (_b = this.getData()) === null || _b === void 0 ? void 0 : _b.username,
                };
                const headers = this.getHeaders();
                const { data: { accessToken, refreshToken, agentToken, username, expiresIn, entrypoint }, } = yield this.xhr.POST(this.urlConfig.refreshToken, actualSessionCCInfo, { headers });
                const newSessionCCData = Object.assign(Object.assign({}, this.getData()), { accessToken,
                    agentToken, refreshToken: refreshToken !== null && refreshToken !== void 0 ? refreshToken : actualSessionCCInfo.refreshToken, username: username !== null && username !== void 0 ? username : actualSessionCCInfo.username, expiresIn, timeOutStamp: (0, timeOut_helper_1.getTimeOutStamp)(expiresIn), entrypoint });
                (0, events_1.publishRefreshedSessionEvent)(newSessionCCData, this.eventBus);
                return Promise.resolve(newSessionCCData);
            }
            catch (e) {
                (0, events_1.publishErrorRefreshingSessionEvent)(e, this.eventBus);
                throw e;
            }
        });
        this.doAgentRefresh = () => __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (!this.xhr) {
                throw Error('Set xhr before use Session');
            }
            try {
                (0, events_1.publishRefreshingSessionEvent)(undefined, this.eventBus);
                const agentToken = yield ((_a = this.usd) === null || _a === void 0 ? void 0 : _a.getMethods().getAgentAccessToken());
                const newSessionData = Object.assign(Object.assign({}, this.getData()), { agentToken: agentToken });
                (0, events_1.publishRefreshedSessionEvent)(newSessionData, this.eventBus);
                return Promise.resolve(newSessionData);
            }
            catch (e) {
                this.finishSession();
                (0, events_1.publishErrorRefreshingSessionEvent)(e, this.eventBus);
                throw e;
            }
        });
        this.urlConfig = urlConfig;
    }
    onRefreshToken(callback) {
        return (0, events_1.subscribeRefreshedSessionEvent)(callback, this.eventBus);
    }
    onRefreshTokenError(callback) {
        return (0, events_1.subscribeErrorRefreshingSessionEvent)(callback, this.eventBus);
    }
    onRefreshingToken(callback) {
        return (0, events_1.subscribeRefreshingSessionEvent)(callback, this.eventBus);
    }
}
exports.MbDRPicasoSession = MbDRPicasoSession;
//# sourceMappingURL=index.js.map